import {Component, QueryList, ViewChildren} from '@angular/core';
import {environment} from "@environment";

@Component({
    selector: 'app-general-conditions',
    templateUrl: './general-conditions.component.html',
    styleUrl: './general-conditions.component.scss',
    standalone: false
})
export class GeneralConditionsComponent {
  @ViewChildren('chapter') chapterDivs: QueryList<any> | undefined;
  environment: any = environment;

  constructor() {}

  trackChapter(index: number, chapter: number): number {
    return chapter;
  }

  scrollToChapter(chapterIndex: number) {
    if (this.chapterDivs) {
      const chapterDivsArray = this.chapterDivs.toArray();
      const chapterElement = chapterDivsArray[chapterIndex-1];
      if (chapterElement) {
        chapterElement.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
}
